import React from 'react';
import { ArticleImport } from '../parse';
import { useTranslation } from 'services/localization';
import { articleCodesStringFromArray, DataRowObject } from '../utils';
import {
	OLD_ARTICLE_CODE_KEY,
	getArticleTableColumns,
	UPDATED_FIELDS_ROW_KEY,
} from '../importTableUtils';
import BaseImportTable from './BaseImportTable';
import { notUndefined } from 'common/utils/common';

interface Props {
	importData: ArticleImport['toUpdate'];
	headerData: DataRowObject;
}

const UpdatedArticlesTable = (props: Props) => {
	const { t } = useTranslation();
	const { importData, headerData } = props;
	const someArticleCodeChanged = importData.some((data) =>
		data.csvFields.updatedFields.includes('article_code'),
	);
	const rowsData = importData.map((data, index) => {
		return {
			...data.csvFields.data,
			[UPDATED_FIELDS_ROW_KEY]: data.csvFields.updatedFields,
			[OLD_ARTICLE_CODE_KEY]: articleCodesStringFromArray(data.existingData.identifiers),
			id: index,
		};
	});

	const requiredFields = [
		someArticleCodeChanged ? OLD_ARTICLE_CODE_KEY : undefined,
		'article_code',
		'sku_code',
	].filter(notUndefined);

	return (
		<BaseImportTable
			rows={rowsData}
			columns={getArticleTableColumns(t, 'toUpdate', headerData, requiredFields)}
		/>
	);
};

export default UpdatedArticlesTable;
